import { loadable } from 'utils';

export const MinimumOrderRulesProgress = loadable(() => import('./MinimumOrderRulesProgress'), {});
